module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isLoading) ? _c('loader', {
    attrs: {
      "loading": _vm.isLoading
    }
  }) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.isItemsDirty) ? _c('div', {
    staticClass: "message"
  }, [_c('div', [_vm._v("Number of added items: " + _vm._s(_vm.addedItems.length))]), _vm._v(" "), _c('div', [_vm._v("Number of removed items: " + _vm._s(_vm.removedItems.length))]), _vm._v(" "), _c('div', [_c('ClientColorButton', {
    attrs: {
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.saveItems
    }
  }, [_vm._v("Save")]), _vm._v(" \n                "), _c('ClientColorButton', {
    attrs: {
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.revertChanges
    }
  }, [_vm._v("Cancel")])], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "forecast-overview"
  }, [_c('div', {
    staticClass: "row mb-4"
  }, [_c('div', {
    staticClass: "col-12 col-xl-4 col-md-6"
  }, [_c('p', {
    staticClass: "forecast-overview-title mb-3 text-uppercase"
  }, [_vm._v("\n                    " + _vm._s(_vm.items.length) + " Item" + _vm._s(_vm.items.length > 1 ? "s" : "") + " included in the forecast\n                ")]), _vm._v(" "), (_vm.items.length > 0) ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('label', {
    staticClass: "mb-2",
    attrs: {
      "for": "forecast-overview-input-filter"
    }
  }, [_vm._v("Search for an item in the forecast :")]), _vm._v(" "), _c('div', {
    staticClass: "w-100"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    attrs: {
      "id": "forecast-overview-input-filter",
      "type": "text"
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  })])])])]) : _vm._e()]), _vm._v(" "), (_vm.canUpdated()) ? _c('div', {
    staticClass: "col-12 col-xl-8 col-md-6 d-flex flex-fill"
  }, [_c('div', {
    staticClass: "row m-0 forecast-overview-add-section w-100"
  }, [_c('div', {
    staticClass: "col-12 col-xl"
  }, [_c('ItemSearch', {
    attrs: {
      "forecast": _vm.forecast,
      "forecast-windows": _vm.forecastWindows,
      "excluded-items": _vm.modifiedItems,
      "resetSearch": _vm.resetSearchBool
    },
    on: {
      "resetSearch": _vm.resetSearch,
      "item-added": _vm.addItem
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-xl-auto mt-3 mt-xl-0 d-flex align-items-end justify-content-center"
  }, [_c('ForcastButton', {
    staticClass: "mx-5",
    attrs: {
      "size": 'l'
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.$router.push("/catalog");
      }
    }
  }, [_vm._v("Add items from catalogue")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-xl-auto mt-3 mt-xl-0 d-flex align-items-end justify-content-center"
  }, [_c('ForecastXlsImport', {
    key: _vm.componentForecastXlsImportKey,
    attrs: {
      "forecast": _vm.forecast
    },
    on: {
      "reload": _vm.reload,
      "reloadItems": function($event) {
        _vm.reloadItems();
      }
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), (_vm.canUpdated()) ? _c('div', {
    staticClass: "col-12 mb-sm-3"
  }, [_c('div', {
    staticClass: "d-flex justify-content-start align-items-center flex-wrap selectedbuttons"
  }, [_c('ForcastButton', {
    staticClass: "mr-3 mt-3",
    attrs: {
      "disabled": _vm.itemSelection.length === _vm.modifiedItems.length,
      "size": 'm'
    },
    on: {
      "click": function($event) {
        _vm.itemSelection = _vm.modifiedItems;
      }
    }
  }, [_vm._v("\n                        Select All\n                    ")]), _vm._v(" "), _c('ForcastButton', {
    staticClass: "mr-3 mt-3",
    attrs: {
      "disabled": _vm.itemSelection.length === 0,
      "size": 'm'
    },
    on: {
      "click": function($event) {
        _vm.itemSelection = [];
      }
    }
  }, [_vm._v("\n                        Select None\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "sorting d-flex justify-content-start align-items-center"
  }, [_c('p', [_vm._v("Sort by :")]), _vm._v(" "), _c('ForcastButton', {
    staticClass: "mr-3 mt-3",
    attrs: {
      "size": 'm'
    },
    on: {
      "click": function($event) {
        _vm.sortItems('reference');
      }
    }
  }, [_vm._v(" Reference ")]), _vm._v(" "), (_vm.hasItemsColor) ? _c('ForcastButton', {
    staticClass: "mr-3 mt-3",
    attrs: {
      "size": 'm'
    },
    on: {
      "click": function($event) {
        _vm.sortItems('color');
      }
    }
  }, [_vm._v(" Color ")]) : _vm._e()], 1), _vm._v(" "), (_vm.itemSelection.length > 0) ? _c('ItemColors', {
    attrs: {
      "items": _vm.itemSelection,
      "forecast": _vm.forecast
    },
    on: {
      "colorsChanged": _vm.colorChange
    }
  }) : _vm._e(), _vm._v(" "), (_vm.itemSelection.length > 0 && _vm.modifiedItems.length > 0 && _vm.hasAccessByProfile(_vm.PROFILES.FORECAST_MANAGER)) ? _c('ForcastButton', {
    staticClass: "mt-3",
    staticStyle: {
      "margin-left": "auto"
    },
    attrs: {
      "size": 'm'
    },
    on: {
      "click": _vm.removeSelection
    }
  }, [_vm._v("\n                        Remove selected items\n                    ")]) : _vm._e()], 1)]) : _vm._e()]), _vm._v(" "), (_vm.items.length > 0) ? _c('div', [_c('ForecastTable', [_c('template', {
    slot: "head-row-2"
  }, [_c('th'), _vm._v(" "), _c('th'), _vm._v(" "), _c('th'), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Item")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Description")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Total QTY")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Markets with prices")]), _vm._v(" "), _c('th')]), _vm._v(" "), _c('template', {
    slot: "body"
  }, [_c('draggable', {
    attrs: {
      "tag": "tbody",
      "list": _vm.items,
      "multi-drag": true,
      "selected-class": "selected-class",
      "group": {
        name: 'people',
        pull: 'clone',
        put: true
      },
      "animation": "200",
      "ghost-class": "ghost",
      "handle": ".handle"
    },
    on: {
      "end": _vm.dragEnd
    }
  }, _vm._l((_vm.modifiedItems), function(item, index) {
    return _c('tr', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!item.hide),
        expression: "!item.hide"
      }],
      key: item.id,
      staticClass: "selected-class",
      class: {
        isDisabled: _vm.isItemDisabled(item)
      }
    }, [_c('td', {
      staticClass: "align-middle text-center handle",
      style: (item.color != null && item.color !== '' ? 'border-left: 15px solid ' + item.color : '')
    }, [_c('img', {
      staticStyle: {
        "ccursor": "grabbing",
        "position": "relative"
      },
      attrs: {
        "src": require("../../../../../static/img/drag-and-drop.svg")
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "align-middle text-center"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.itemSelection),
        expression: "itemSelection"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": item,
        "checked": Array.isArray(_vm.itemSelection) ? _vm._i(_vm.itemSelection, item) > -1 : (_vm.itemSelection)
      },
      on: {
        "__c": function($event) {
          var $$a = _vm.itemSelection,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = item,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.itemSelection = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.itemSelection = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.itemSelection = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "align-middle text-center"
    }, [_vm._v(_vm._s(_vm.getOrder(item, index)))]), _vm._v(" "), _c('td', {
      staticClass: "align-middle"
    }, [_c('ItemImage', {
      staticClass: "item-image",
      attrs: {
        "item": item,
        "height": '100px',
        "width": '100px',
        "align": "center"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "align-middle"
    }, [_c('ItemDescription', {
      attrs: {
        "item": item,
        "forecast": _vm.forecast
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "align-middle text-center"
    }, [_vm._v(_vm._s(_vm.getQuantities(item)))]), _vm._v(" "), _c('td', {
      staticClass: "align-middle"
    }, [_c('AllPricesInfo', {
      attrs: {
        "item": item,
        "forecast-windows": _vm.forecastWindows
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "align-middle",
      staticStyle: {
        "text-align": "right",
        "padding-right": "20px"
      }
    }, [(_vm.hasAccessByProfile(_vm.PROFILES.FORECAST_MANAGER)) ? _c('ForcastButton', {
      attrs: {
        "size": 'm',
        "disabled": !_vm.canRemoveItem(item)
      },
      on: {
        "click": function($event) {
          _vm.removeItems([item]);
        }
      }
    }, [_vm._v("Remove")]) : _vm._e(), _vm._v(" "), _c('ItemQuantitiesButton', {
      staticStyle: {
        "margin-left": "20px"
      },
      attrs: {
        "item": item,
        "forecast": _vm.forecast
      }
    })], 1)])
  }))], 1)], 2)], 1) : _c('div', [_c('p', {
    staticClass: "text-center no-items"
  }, [_vm._v("No item in this forecast yet")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-978c5876","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forecasts/pages/sections/ItemManager.vue
// module id = 3320
// module chunks = 0